import Link from 'next/link'
import clsx from 'clsx'
import styles from './styles.module.scss'

type Item = {
  breadcrumb: string
  href: string
}

type Props = {
  items: Item[]
  lastItem: string
  code?: string
  wrapperClassName?: string
}

export const Breadcrumbs = ({
  items,
  lastItem,
  code,
  wrapperClassName,
}: Props) => {
  const formatLastItem = () => {
    if (code) return `${lastItem} (${code})`
    return `${lastItem}`
  }

  if (!items) return null

  return (
    <div className={clsx(styles.breadCrumbsContainer, wrapperClassName)}>
      <div className={styles.breadCrumbs}>
        {items.map(item => {
          return (
            <span key={item.href}>
              <>
                <Link className={styles.item} href={item.href} prefetch={false}>
                  {item.breadcrumb}
                </Link>
                <span className={styles.separator}>/</span>
              </>
            </span>
          )
        })}
        <span className={clsx(styles.item, styles.itemInactive)}>
          {formatLastItem()}
        </span>
      </div>
    </div>
  )
}

export default Breadcrumbs
